<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form-item
            :label="$l('table_head_chineseName') || '中文名称'"
            prop="prjCategoryName"
          >
            <el-input
              v-model="formData.prjCategoryName"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form-item
            :label="$l('table_head_englishName') || '英文名称'"
            prop="prjCategoryEnName"
          >
            <el-input
              v-model="formData.prjCategoryEnName"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item
            :label="$l('table_label_isSampleName') || '是否打样'"
            prop="isSample"
          >
            <el-radio-group
              style="width: 100%"
              size="small"
              :disabled="disabled"
              v-model="formData.isSample"
            >
              <el-radio label="Y">{{ $l("INDEX.YES") || "是" }}</el-radio>
              <el-radio label="N">{{ $l("INDEX.NO") || "否" }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item
            :label="$l('INDEX.Status') || '状态'"
            prop="prjCategoryStatus"
          >
            <el-radio-group
              style="width: 100%"
              size="small"
              :disabled="disabled"
              v-model="formData.prjCategoryStatus"
            >
              <el-radio label="Y">{{
                $l("INDEX.form_label_valid") || "有效"
              }}</el-radio>
              <el-radio label="N">{{
                $l("INDEX.form_label_invalid") || "无效"
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataVisible">
          <div style="font-size: 14px; color: #717171">
            <span
              >Create：{{
                formData.createByName ? formData.createByName : "--"
              }}
              at {{ formData.createDate ? formData.createDate : "--" }}</span
            >
          </div>
          <div style="font-size: 14px; color: #717171">
            <span
              >Modify：{{
                formData.modifyByName ? formData.modifyByName : "--"
              }}
              at {{ formData.modifyDate ? formData.modifyDate : "--" }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button @click="close()" size="small">{{
          this.$l("INDEX.btn_no_save") || "不保存"
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          this.$l("INDEX.btn_save") || "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";

export default {
  props: {
    disabled: Boolean,
    prjCategoryCode: String,
    createDataVisible: Boolean,
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        prjCategoryCode: "",
        prjCategoryName: "",
        prjCategoryEnName: "",
        prjCategoryStatus: "Y",
        isSample: "N",
        createByName: "",
        createDate: "",
        modifyByName: "",
        modifyDate: "",
      },
      rules: {
        prjCategoryName: [
          { required: true, message: "请输入中文名称", trigger: "blur" },
          { max: 50, message: "长度在50个字符以内", trigger: "blur" },
        ],
        prjCategoryEnName: [
          { max: 50, message: "长度在50个字符以内", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.prjCategoryCode) return;
      this.$api
        .prjCategoryDetailApi({
          prjCategoryCode: this.prjCategoryCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    // 保存数据
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) return (this.backDialogVisible = false);
      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$api
        .prjCategorySaveApi(this.formData)
        .then(() => {
          loadingInstance.close();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || "保存成功",
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          loadingInstance.close();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.backDialogVisible = true;
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>
